import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("b", null, "Please correct the following error(s):", -1)
const _hoisted_4 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_5 = { class: "table table-responsive-sm table-bordered table-striped table-sm mb-5" }
const _hoisted_6 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", null, "Email address "),
    /*#__PURE__*/_createVNode("th", null, "Event 제목"),
    /*#__PURE__*/_createVNode("th", null, "Time Stamp")
  ])
], -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: ["card", {loading: _ctx.loading}]
  }, [
    _createVNode("div", _hoisted_1, [
      (_ctx.errors.length)
        ? (_openBlock(), _createBlock("p", _hoisted_2, [
            _hoisted_3,
            _createVNode("ul", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
                return (_openBlock(), _createBlock("li", { key: error }, _toDisplayString(error), 1))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", null, [
        _createVNode("h4", null, "Events log for " + _toDisplayString(_ctx.email), 1),
        (_ctx.eventsLog.length)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("table", _hoisted_5, [
                _hoisted_6,
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.eventsLog, (item) => {
                    return (_openBlock(), _createBlock("tr", {
                      key: item.event_timestamp
                    }, [
                      _createVNode("td", null, _toDisplayString(item.email_address), 1),
                      _createVNode("td", null, _toDisplayString(item.event_name), 1),
                      _createVNode("td", null, _toDisplayString(_ctx.dateTimeHelper.timestampToDateTime(item.event_timestamp)), 1)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : (_openBlock(), _createBlock("p", _hoisted_7, [
              (!_ctx.loading)
                ? (_openBlock(), _createBlock("span", _hoisted_8, "This user does not have any event yet!"))
                : _createCommentVNode("", true)
            ]))
      ])
    ])
  ], 2))
}